import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "fw-light fs-4" }
const _hoisted_5 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Email", -1)
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_11 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-dark-blue fw-bolder me-4"
}
const _hoisted_12 = { class: "indicator-label" }
const _hoisted_13 = { class: "indicator-progress" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      onSubmit: _ctx.onSubmitForgotPassword,
      id: "kt_login_password_reset_form",
      "validation-schema": _ctx.forgotPassword
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.translate("LOGIN_FORGOT_PSW_LINK")), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.translate("LOGIN_FORGOT_PASSWORD_MESSAGE")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/sign-in",
              class: "link-primary fw-bolder"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.translate("LOGIN_BACK_TO_HOME_MESSAGE")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Field, {
            class: "form-control",
            type: "email",
            placeholder: "",
            name: "email",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate("BUTTON_SUBMIT")), 1),
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
              _hoisted_14
            ])
          ], 512),
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn btn-lg btn-dark-blue fw-bolder"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_DISCARD_CHANGES")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}